import React, { useState, useEffect } from 'react';
import Header from '../../components/ui/Header';
import BreadcrumbNavigation from '../../components/ui/BreadcrumbNavigation';
import QuickActionFAB from '../../components/ui/QuickActionFAB';
import StatusPipeline from './components/StatusPipeline';
import OrderList from './components/OrderList';
import TrackingPanel from './components/TrackingPanel';
import OrderFilters from './components/OrderFilters';
import BulkOperationsBar from './components/BulkOperationsBar';

const OrderFulfillmentTracking = () => {
  const [orders, setOrders] = useState([]);
  const [filteredOrders, setFilteredOrders] = useState([]);
  const [selectedOrders, setSelectedOrders] = useState([]);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [filterStatus, setFilterStatus] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [dateRange, setDateRange] = useState({ start: null, end: null });
  const [isLoading, setIsLoading] = useState(true);

  // Mock data for orders
  const mockOrders = [
    {
      id: 'ORD-2024-001',
      customerName: 'Tech Solutions S.L.',
      customerEmail: 'pedidos@techsolutions.es',
      customerPhone: '+34 91 234 5678',
      products: [
        { name: 'Laptop Dell XPS 13', quantity: 2, sku: 'LAP-DELL-001' },
        { name: 'Monitor LG UltraWide 34"', quantity: 1, sku: 'MON-LG-004' }
      ],
      totalAmount: 3199.97,
      status: 'shipped',
      priority: 'high',
      orderDate: new Date('2024-12-10'),
      estimatedDelivery: new Date('2024-12-14'),
      deliveryAddress: {
        street: 'Calle Gran Vía 28',
        city: 'Madrid',
        postalCode: '28013',
        country: 'España'
      },
      trackingNumber: 'MRW123456789',
      carrier: 'MRW',
      statusHistory: [
        { status: 'processing', timestamp: new Date('2024-12-10T09:00:00'), note: 'Pedido recibido y en procesamiento' },
        { status: 'packed', timestamp: new Date('2024-12-10T14:30:00'), note: 'Productos empaquetados' },
        { status: 'shipped', timestamp: new Date('2024-12-11T08:15:00'), note: 'Enviado con MRW - Nº seguimiento: MRW123456789' }
      ],
      lastUpdated: new Date('2024-12-11T08:15:00')
    },
    {
      id: 'ORD-2024-002',
      customerName: 'Innovación Digital',
      customerEmail: 'compras@innovaciondigital.com',
      customerPhone: '+34 93 456 7890',
      products: [
        { name: 'iPhone 15 Pro', quantity: 5, sku: 'PHN-IPH-002' },
        { name: 'Teclado Logitech MX Keys', quantity: 5, sku: 'KEY-LOG-005' }
      ],
      totalAmount: 6549.95,
      status: 'in_transit',
      priority: 'medium',
      orderDate: new Date('2024-12-09'),
      estimatedDelivery: new Date('2024-12-13'),
      deliveryAddress: {
        street: 'Avenida Diagonal 500',
        city: 'Barcelona',
        postalCode: '08006',
        country: 'España'
      },
      trackingNumber: 'SEUR987654321',
      carrier: 'SEUR',
      statusHistory: [
        { status: 'processing', timestamp: new Date('2024-12-09T10:00:00'), note: 'Pedido recibido' },
        { status: 'packed', timestamp: new Date('2024-12-09T16:00:00'), note: 'Empaquetado completado' },
        { status: 'shipped', timestamp: new Date('2024-12-10T09:00:00'), note: 'Enviado con SEUR' },
        { status: 'in_transit', timestamp: new Date('2024-12-11T12:00:00'), note: 'En reparto, llegada estimada hoy antes de las 18:00' }
      ],
      lastUpdated: new Date('2024-12-11T12:00:00')
    },
    {
      id: 'ORD-2024-003',
      customerName: 'Sistemas Avanzados',
      customerEmail: 'logistica@sistemasavanzados.es',
      customerPhone: '+34 95 123 4567',
      products: [
        { name: 'Samsung Galaxy Tab S9', quantity: 3, sku: 'TAB-SAM-003' }
      ],
      totalAmount: 2549.97,
      status: 'processing',
      priority: 'low',
      orderDate: new Date('2024-12-11'),
      estimatedDelivery: new Date('2024-12-15'),
      deliveryAddress: {
        street: 'Polígono Industrial Los Álamos',
        city: 'Sevilla',
        postalCode: '41940',
        country: 'España'
      },
      trackingNumber: null,
      carrier: null,
      statusHistory: [
        { status: 'processing', timestamp: new Date('2024-12-11T11:30:00'), note: 'Pedido recibido, verificando stock' }
      ],
      lastUpdated: new Date('2024-12-11T11:30:00')
    },
    {
      id: 'ORD-2024-004',
      customerName: 'Consultoría Madrid',
      customerEmail: 'admin@consultoriamadrid.es',
      customerPhone: '+34 91 789 0123',
      products: [
        { name: 'Laptop Dell XPS 13', quantity: 1, sku: 'LAP-DELL-001' },
        { name: 'Teclado Logitech MX Keys', quantity: 1, sku: 'KEY-LOG-005' }
      ],
      totalAmount: 1409.98,
      status: 'delivered',
      priority: 'medium',
      orderDate: new Date('2024-12-08'),
      estimatedDelivery: new Date('2024-12-12'),
      actualDelivery: new Date('2024-12-12T15:30:00'),
      deliveryAddress: {
        street: 'Calle Serrano 125',
        city: 'Madrid',
        postalCode: '28006',
        country: 'España'
      },
      trackingNumber: 'DHL567890123',
      carrier: 'DHL',
      signedBy: 'María García - Recepcionista',
      statusHistory: [
        { status: 'processing', timestamp: new Date('2024-12-08T09:00:00'), note: 'Pedido procesado' },
        { status: 'packed', timestamp: new Date('2024-12-08T15:00:00'), note: 'Empaquetado' },
        { status: 'shipped', timestamp: new Date('2024-12-09T08:00:00'), note: 'Enviado con DHL' },
        { status: 'in_transit', timestamp: new Date('2024-12-12T10:00:00'), note: 'En reparto' },
        { status: 'delivered', timestamp: new Date('2024-12-12T15:30:00'), note: 'Entregado y firmado por María García' }
      ],
      lastUpdated: new Date('2024-12-12T15:30:00')
    },
    {
      id: 'ORD-2024-005',
      customerName: 'StartUp Valencia',
      customerEmail: 'office@startupvalencia.com',
      customerPhone: '+34 96 345 6789',
      products: [
        { name: 'Monitor LG UltraWide 34"', quantity: 4, sku: 'MON-LG-004' }
      ],
      totalAmount: 2399.96,
      status: 'packed',
      priority: 'high',
      orderDate: new Date('2024-12-11'),
      estimatedDelivery: new Date('2024-12-14'),
      deliveryAddress: {
        street: 'Ciudad de las Artes y las Ciencias',
        city: 'Valencia',
        postalCode: '46013',
        country: 'España'
      },
      trackingNumber: null,
      carrier: 'Correos',
      statusHistory: [
        { status: 'processing', timestamp: new Date('2024-12-11T08:00:00'), note: 'Pedido en procesamiento' },
        { status: 'packed', timestamp: new Date('2024-12-12T10:15:00'), note: 'Empaquetado completado, listo para envío' }
      ],
      lastUpdated: new Date('2024-12-12T10:15:00')
    }
  ];

  useEffect(() => {
    setIsLoading(true);
    setTimeout(() => {
      setOrders(mockOrders);
      setFilteredOrders(mockOrders);
      setIsLoading(false);
    }, 800);
  }, []);

  // Filter logic
  useEffect(() => {
    let filtered = [...orders];

    // Status filter
    if (filterStatus !== 'all') {
      filtered = filtered.filter(order => order.status === filterStatus);
    }

    // Search filter
    if (searchTerm) {
      filtered = filtered.filter(order =>
        order.id.toLowerCase().includes(searchTerm.toLowerCase()) ||
        order.customerName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        order.trackingNumber?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    // Date range filter
    if (dateRange.start && dateRange.end) {
      filtered = filtered.filter(order => {
        const orderDate = new Date(order.orderDate);
        return orderDate >= dateRange.start && orderDate <= dateRange.end;
      });
    }

    setFilteredOrders(filtered);
  }, [orders, filterStatus, searchTerm, dateRange]);

  const handleStatusUpdate = (orderId, newStatus, note = '') => {
    setOrders(prevOrders =>
      prevOrders.map(order => {
        if (order.id === orderId) {
          const updatedOrder = {
            ...order,
            status: newStatus,
            lastUpdated: new Date(),
            statusHistory: [
              ...order.statusHistory,
              {
                status: newStatus,
                timestamp: new Date(),
                note: note || `Estado actualizado a ${getStatusLabel(newStatus)}`
              }
            ]
          };
          
          // Update tracking number if shipped
          if (newStatus === 'shipped' && !order.trackingNumber) {
            updatedOrder.trackingNumber = `TRK${Date.now()}`;
            updatedOrder.carrier = 'MRW';
          }
          
          return updatedOrder;
        }
        return order;
      })
    );
  };

  const handleBulkStatusUpdate = (orderIds, newStatus) => {
    orderIds.forEach(orderId => {
      handleStatusUpdate(orderId, newStatus);
    });
    setSelectedOrders([]);
  };

  const handleDeliveryConfirmation = (orderId, signedBy, photo = null) => {
    setOrders(prevOrders =>
      prevOrders.map(order => {
        if (order.id === orderId) {
          return {
            ...order,
            status: 'delivered',
            actualDelivery: new Date(),
            signedBy,
            deliveryPhoto: photo,
            lastUpdated: new Date(),
            statusHistory: [
              ...order.statusHistory,
              {
                status: 'delivered',
                timestamp: new Date(),
                note: `Entregado y firmado por ${signedBy}`
              }
            ]
          };
        }
        return order;
      })
    );
  };

  const handleOrderSelect = (orderId) => {
    setSelectedOrders(prev => {
      if (prev.includes(orderId)) {
        return prev.filter(id => id !== orderId);
      } else {
        return [...prev, orderId];
      }
    });
  };

  const handleSelectAll = () => {
    if (selectedOrders.length === filteredOrders.length) {
      setSelectedOrders([]);
    } else {
      setSelectedOrders(filteredOrders.map(order => order.id));
    }
  };

  const handleSendNotification = (orderId, type = 'status_update') => {
    console.log(`Sending ${type} notification for order ${orderId}`);
    // Implement notification logic
  };

  const getStatusLabel = (status) => {
    const labels = {
      processing: 'Procesando',
      packed: 'Empaquetado',
      shipped: 'Enviado',
      in_transit: 'En tránsito',
      delivered: 'Entregado'
    };
    return labels[status] || status;
  };

  const getStatusStats = () => {
    const stats = {
      processing: orders.filter(o => o.status === 'processing').length,
      packed: orders.filter(o => o.status === 'packed').length,
      shipped: orders.filter(o => o.status === 'shipped').length,
      in_transit: orders.filter(o => o.status === 'in_transit').length,
      delivered: orders.filter(o => o.status === 'delivered').length
    };
    return stats;
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main className="pt-16">
        <div className="max-w-7xl mx-auto px-4 lg:px-6 py-6">
          <BreadcrumbNavigation />
          
          {/* Page Header */}
          <div className="mb-6">
            <h1 className="text-2xl font-heading font-semibold text-text-primary mb-2">
              Seguimiento de Pedidos
            </h1>
            <p className="text-text-muted">
              Monitorea el estado de los pedidos desde el procesamiento hasta la entrega
            </p>
          </div>

          {/* Status Pipeline */}
          <div className="mb-6">
            <StatusPipeline stats={getStatusStats()} />
          </div>

          {/* Filters */}
          <div className="mb-6">
            <OrderFilters
              filterStatus={filterStatus}
              setFilterStatus={setFilterStatus}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              dateRange={dateRange}
              setDateRange={setDateRange}
              totalOrders={orders.length}
              filteredOrders={filteredOrders.length}
            />
          </div>

          {/* Main Content Grid */}
          <div className="grid grid-cols-12 gap-6">
            {/* Order List */}
            <div className="col-span-12 lg:col-span-6">
              <OrderList
                orders={filteredOrders}
                selectedOrders={selectedOrders}
                onOrderSelect={handleOrderSelect}
                onSelectAll={handleSelectAll}
                onStatusUpdate={handleStatusUpdate}
                onRowClick={setSelectedOrder}
                onSendNotification={handleSendNotification}
                isLoading={isLoading}
              />
            </div>

            {/* Tracking Panel */}
            <div className="col-span-12 lg:col-span-6">
              <TrackingPanel
                selectedOrder={selectedOrder}
                onStatusUpdate={handleStatusUpdate}
                onDeliveryConfirmation={handleDeliveryConfirmation}
                onSendNotification={handleSendNotification}
                onClose={() => setSelectedOrder(null)}
              />
            </div>
          </div>
        </div>
      </main>

      {/* Bulk Operations Bar */}
      <BulkOperationsBar
        selectedCount={selectedOrders.length}
        onBulkStatusUpdate={handleBulkStatusUpdate}
        onBulkNotification={(type) => {
          selectedOrders.forEach(orderId => handleSendNotification(orderId, type));
          setSelectedOrders([]);
        }}
        onClearSelection={() => setSelectedOrders([])}
      />

      <QuickActionFAB />
    </div>
  );
};

export default OrderFulfillmentTracking;